import * as Constantes from '../utils/constantes'

export const popupWindow = (url, title, w, h) => {
    let y = window.outerHeight / 2 + window.screenY - (h / 2) - 40
    let x = window.outerWidth / 2 + window.screenX - (w / 2)

    return window.open(url, title, 'width=' + w + ', height=' + h + ', top=' + y + ', left=' + x + ', scrollbars=NO')
}

export const formatearFecha = (fecha) => {
    if (fecha !== Constantes.CADENA_VACIA) {
        if (fecha.constructor.name === 'String' && fecha.indexOf('-') > -1) {
            return fecha
        } else {
            return fecha.toISOString().substr(0, 10)
        }
    } else {
        return Constantes.CADENA_VACIA
    }
}

export const formatearTextoAFecha = (fechaString) => {
    let fechaSalida = null
    let dateParts = null
    if (fechaString.constructor.name === 'Date') {
        fechaSalida = fechaString
    } else if (fechaString.constructor.name === 'String' && fechaString.indexOf('/') > -1) {
        dateParts = fechaString.split("/")
        fechaSalida = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])
    } else if (fechaString.constructor.name === 'String' && fechaString.indexOf('-') > -1) {
        dateParts = fechaString.substr(0, 10).split("-")
        fechaSalida = new Date(dateParts[0], dateParts[1] - 1, dateParts[2])
    }
    return fechaSalida !== null ? fechaSalida.toISOString().substr(0, 10) : ''
}

/*FUNCIONES EXTRAS PARA SER UTILIZADAS EN EL NUEVO FORMATO DE FECHAS*/
export const transformarFechaToDatePicker = (fecha) => {
    if(fecha !== undefined && fecha !== null) {
        if (fecha.constructor.name === 'Date') {
            let fechaDate = new Date(fecha)
            return {
                year: fechaDate.getFullYear(),
                month: fechaDate.getMonth() + 1,
                day: fechaDate.getDate()
            }
        } else if (fecha.constructor.name === 'String' && fecha.indexOf('-') > -1) {
            let dateParts = fecha.split('-')
            let fec = new Date(dateParts[0], dateParts[1] - 1, dateParts[2].includes('T') ? dateParts[2].split('T')[0] : dateParts[2])
            return {
                year: fec.getFullYear(),
                month: fec.getMonth() + 1,
                day: fec.getDate()
            }
            /*return {
                year: dateParts[0],
                month: dateParts[1],
                day: dateParts[2].includes('T') ? dateParts[2].split('T')[0] : dateParts[2]
            }*/
        }
    }
    return null
}

export const transformarFechaPersonIDToFecha = (fechaID) => {
    let fecha = new Date()
    fecha.setDate(parseInt(fechaID.substr(-20, 2)))
    fecha.setMonth(parseInt(fechaID.substr(3, 5)) - 1)
    fecha.setFullYear(parseInt(fechaID.substr(-4)))
    fecha.setHours(0, 0, 0, 0)
    return fecha
}

export const transformarDatePickerToFecha = (picker) => {
    let fecha = new Date(picker.year, picker.month - 1, picker.day)
    /*fecha.setDate(picker.day)
    fecha.setMonth(picker.month - 1)
    fecha.setFullYear(picker.year)*/
    fecha.setHours(0, 0, 0, 0)
    return fecha
}

export const formatearFechaP = (fecha) => {
    if (fecha !== Constantes.CADENA_VACIA) {
        return fecha.toISOString().substr(0, 10) + 'T00:00:00'
    } else {
        return Constantes.CADENA_VACIA
    }
}
/***************************************************** */

export const formatearFechaTexto = (fecha) => {
    return fecha.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
}

export const formatearFechaTextoFormat = (fecha) => {
    var d = new Date(fecha),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [year, month, day].join('-')
}

export const esFechaValida = (fecha) => {
    return fecha instanceof Date && !isNaN(fecha)
}

export const esEmailValido = (email) => {
    let correo = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/
    return email.match(correo)
}

export const obtenerMinutosFechaHoy = (fecha) => {
    const fechaEntrada = new Date(fecha)
    const hoy = new Date()
    const diffMs = (fechaEntrada - hoy)
    const diffMins = Math.floor(diffMs / 1000 / 60)
    return diffMins;
}

export const validarSoloLetras = (event, ref) => {
    ref.current.value = event.target.value.replace(/[^\w\s]/gi, "")
}

export const obtenerBase64 = (texto) => {
    return texto.substr((texto).indexOf('base64') + 7)
}

export const pintarBase64 = (texto) => {
    return 'data:image/png;base64,' + texto
}

export const esTarjetaVencida = (fechaVencimiento) => {
    let datos = fechaVencimiento.split('/')
    let hoy = new Date()
    let mes = hoy.getMonth()
    let anio = hoy.getFullYear()

    let indTarjeta = parseInt(datos[0]) + parseInt(datos[1]) * 100
    let indHoy = parseInt(mes) + parseInt(anio) * 100

    return indTarjeta < indHoy
}

export const mostrarCamelCase = (str) => {
    let textSalida = '';
    str.split(' ').forEach(function (el, idx) {
        var add = el.toLowerCase()
        if (el !== '') {
            textSalida += (idx === 0 ? add : add[0].toUpperCase() + add.slice(1));
        } else {
            textSalida += (idx !== 0 ? ' ' : '')
        }
    });

    return textSalida.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); });
}

export const esFechaAnterior = (fecha) => {
    let hoy = new Date()
    return new Date(fecha) < hoy
}

const minFecha = (fechaString) => {
    let fechaSalida = null
    if (fechaString.constructor.name === 'Date') {
        let esaFecha = fechaString.getTimezoneOffset() * 60000
        fechaSalida = (new Date(Date.now() - esaFecha))
    }
    return fechaSalida !== null ? fechaSalida.toISOString().substr(0, 10) : ''
}

export const esFechaPosterior = (fecha) => {
    let hoy = minFecha(new Date())
    return minFecha(new Date(fecha)) >= hoy //|| new Date(fecha) === hoy
}

export const mostrarFormatoMoneda = (monto, codMoneda, mostrarCero) => {
    monto = parseFloat(monto)
    if (monto !== undefined && monto !== null && monto > 0) {
        monto = Math.round((monto + Number.EPSILON) * 100) / 100
        monto = monto ? monto.toFixed(2).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : ''
    } else {
        if (mostrarCero !== undefined && mostrarCero) {
            monto = '0.00'
        } else {
            monto = 0
        }
    }

    if (codMoneda !== undefined) {
        let simbolo = Constantes['SIMBOLO_MONEDA_' + codMoneda]
        return simbolo + monto
    } else {
        return monto
    }
}

export const formatoMonedaLaboral = (monto) => {
    return monto ? monto.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : ''
}

export const cantidadStringToFloat = (montoString) => {
    let valor = montoString.toString().replace(/,/g, '')
    return parseFloat(valor)
}

export const isFotoValida = (attach) => {
    let valor = attach.includes('null') || attach.includes('undefined')
    return valor
}

export const generarCorrelativoVisa = () => {
    var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hours = d.getHours(),
        minute = d.getMinutes(),
        second = d.getSeconds();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year.toString().substring(2, 4), month, day, hours, minute, second].join('');
}

export const generarCorrelativo = () => {
    return Math.random().toString().substring(2, 20)
}

export const formatearMonedaVisa = (montoNumber) => {
    return parseFloat(montoNumber).toFixed(2).toString()
}

export const formatearExpiracionVisaDate = (fecExpiracionVisa) => {
    let anio = fecExpiracionVisa.substring(0, 2)
    let mes = fecExpiracionVisa.substring(2, 4)
    let dia = fecExpiracionVisa.substring(4, 6)
    let hora = fecExpiracionVisa.substring(6, 8)
    let minuto = fecExpiracionVisa.substring(8, 10)
    let segundo = fecExpiracionVisa.substring(10, 12)

    let fecha = new Date()
    fecha.setFullYear(20 + anio, mes - 1, dia)
    fecha.setHours(hora, minuto, segundo, 0)

    return fecha
}

export const obtenerTablasMaestras = (tablasMaestras, codTablaMaestra) => {
    let tablaMaestra = []
    if (tablasMaestras !== undefined && tablasMaestras !== null && tablasMaestras.length > 0) {
        let tablaMaestraAux = tablasMaestras.filter(tabMaestra => tabMaestra.codigoMaestro === codTablaMaestra)[0]
        tablaMaestra = tablaMaestraAux !== undefined ? tablaMaestraAux.registros : []
    }

    return tablaMaestra
}

export const obtenerValorTablaMaestra = (tablasMaestras, codTablaMaestra, codigoCampo) => {
    if(codigoCampo !== undefined && codigoCampo !== null && codigoCampo.trim() !== Constantes.CADENA_VACIA) {
        let tablaMaestra = obtenerTablasMaestras(tablasMaestras, codTablaMaestra)
        if(tablaMaestra !== undefined && tablaMaestra !== null && tablaMaestra.length > 0) {
            let item = tablaMaestra.filter(itemAux => itemAux.id === parseInt(codigoCampo))[0]
            return item !== undefined && item !== null ? item.valor : ''
        }
    }
    return null
}

export const obtenerValor = (valor, tipo) => {
    if (Constantes.TIPO_DATO_TEXTO === tipo) {
        valor = obtenerReglaTexto(valor);
    } else if (Constantes.TIPO_DATO_ALPHA_NUMERICO === tipo) {
        valor = obtenerAlphanumerico(valor);
    } else if (Constantes.TIPO_DATO_TEXTO_NUMERICO === tipo) {
        valor = obtenerReglaNumerico(valor);
    } else if (Constantes.TIPO_DATO_TEXTO_EMAIL === tipo) {
    } else if (Constantes.TIPO_DATO_NUMERICO === tipo) {
        valor = valor !== '' && !isNaN(valor) ? parseInt(obtenerReglaNumerico(valor)) : '';
    } else if (Constantes.TIPO_DATO_DECIMAL === tipo) {
        valor = valor !== '' && !isNaN(valor) ? parseFloat(obtenerReglaDecimal(valor)) : '';
    } else if (Constantes.TIPO_DATO_FECHA === tipo) {
        valor = transformarDatePickerToFecha(valor);
    } else if (Constantes.TIPO_DATO_COMBO === tipo) {
        valor = parseInt(valor);
    } else if (Constantes.TIPO_DATO_COMBO_TEXTO === tipo) {
        valor = valor !== '-1' ? valor : null;
    } else if (Constantes.TIPO_DATO_OTRO === tipo) {
    } else if (Constantes.TIPO_DATO_TEXTO_MAYUSCULA === tipo) {
        valor = valor !== undefined && valor !== null ? obtenerReglaTexto(valor).toUpperCase() : null;
    } else if (Constantes.TIPO_DATO_ALPHA_NUMERICO_MAYUSCULA === tipo) {
        valor = valor !== undefined && valor !== null ? obtenerAlphanumerico(valor).toUpperCase() : null;
    } else if (Constantes.TIPO_DATO_TEXTO_EMAIL_MAYUSCULA === tipo) {
        valor = valor !== undefined && valor !== null ? valor.toUpperCase() : null;
    } else if (Constantes.TIPO_DATO_OTRO_MAYUSCULA === tipo) {
        valor = valor !== undefined && valor !== null ? valor.toUpperCase() : null;
    }
    return valor;
}

export const obtenerReglaTexto = (valor) => {
    if (valor !== null) {
        let salida = valor.replace(/[^a-z A-Z À-ÿ \u00f1\u00d1]/gi, '');
        if (salida !== Constantes.CADENA_VACIA) {
            return salida;
        } else {
            return '';
        }
    } else {
        return '';
    }
}

export const obtenerAlphanumerico = (valor) => {
    if (valor !== null) {
        let salida = valor.replace(/[^a-z A-Z 0-9]+$/gi, '');
        if (salida !== Constantes.CADENA_VACIA) {
            return salida;
        } else {
            return '';
        }
    } else {
        return '';
    }
}

export const obtenerReglaNumerico = (valor) => {
    valor = valor.toString().trim();
    if (valor !== null) {
        let salida = valor.replace(/[^0-9 \u00f1\u00d1]/gi, '');
        if (!isNaN(salida) && salida !== Constantes.CADENA_VACIA) {
            return salida;
        } else {
            return '';
        }
    } else {
        return '';
    }
}

export const obtenerReglaDecimal = (valor) => {
    valor = valor.toString().trim()
    if (valor !== null) {
        let salida = valor.replace(/[^0-9. \u00f1\u00d1]/gi, "")
        if (!isNaN(salida) && salida !== Constantes.CADENA_VACIA) {
            return salida
        } else {
            return ''
        }
    } else {
        return ''
    }
}

export const ordenarListaXCampo = (ascendente, lista, campo, subcampo) => {
    const compare = (a, b) => {
        if (subcampo !== undefined && subcampo !== null && subcampo.trim() !== Constantes.CADENA_VACIA) {
            if (a[campo][subcampo] < b[campo][subcampo]) {
                return ascendente ? -1 : 1
            } else if (a[campo][subcampo] > b[campo][subcampo]) {
                return ascendente ? 1 : -1
            }
        } else {
            if (a[campo] < b[campo]) {
                return ascendente ? -1 : 1
            } else if (a[campo] > b[campo]) {
                return ascendente ? 1 : -1
            }
        }

        return 0
    }

    if (lista !== undefined && lista !== null && lista.length > 0) {
        return lista.sort(compare)
    } else {
        return lista
    }
}

export const reemplazarUrlServicio = (urlSalida, arrayAtributos) => {
    arrayAtributos.map((atributo) => {
        let variable = `{${atributo.campo}}`
        urlSalida = urlSalida.replace(variable, atributo.valor)
        return atributo
    })
    return urlSalida
}

export const transformarMonto = (monto, codMonedaOrigen, codMonedaDestino, tipoCambio) => {
    let montoSalida = 0
    if (isNaN(monto) || monto === null) {
        monto = 0
    }
    if (codMonedaOrigen === null || codMonedaOrigen === undefined) {
        codMonedaOrigen = Constantes.COD_MONEDA_DOLARES
    }
    if (codMonedaOrigen === codMonedaDestino) {
        montoSalida = parseFloat(monto)
    } else {
        if (codMonedaDestino === Constantes.COD_MONEDA_DOLARES) {
            montoSalida = parseFloat(monto) / parseFloat(tipoCambio)
        } else {
            montoSalida = parseFloat(monto) * parseFloat(tipoCambio)
        }
    }
    return montoSalida
}

export const tieneProyecciones = (codigoProducto) => {
    return Constantes.CODIGO_PRODUCTOS_PROYECCION.indexOf(codigoProducto) > -1
}

export const procesarRespuesta = async (options) => {
    let respuesta = {
        auditResponse: {
            codigoRespuesta: '001',
            mensajeRespuesta: 'Ejecucion incorrecta'
        }
    }

    try {
        const response = await fetch(options.url, options)
        if (response.ok) {
            const json = await response.json();
            if (json.auditResponse === undefined) {
                let entity = json.entity !== undefined ? json.entity : json
                respuesta = {
                    entity: entity,
                    auditResponse: {
                        codigoRespuesta: '0',
                        mensajeRespuesta: 'Ejecucion correcta'
                    }
                }
            } else {
                respuesta = json
            }
        } else {
            const json = await response.json();
            if (json.auditResponse !== undefined) {
                respuesta = json
            }
        }
    } catch (error) {
        console.error('Error Invocacion:', error)
    }

    return respuesta
}

export const formatoMoneda = (monto) => {
    return monto ? monto.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : ''
}

export const obtenerFechaHoy = () => {
    const date = new Date()
    return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${(
        '0' + date.getDate()
    ).slice(-2)}`
}

export const obtenerTiempoFaltante = (user) => {
    if(user !== undefined && user !== null && user.fechaSesion !== undefined && user.fechaSesion !== null) {
        let fechaSesion = new Date(user.fechaSesion)
        let ahora = new Date()
        let diferencia = Math.abs(ahora - fechaSesion)
        return ((Constantes.TIEMPO_SESION * 60) - Math.floor(diferencia / 1000))
    } else {
        return null
    }
}

export const saberConyuge = (beneficiarios) => {
    let tiene = beneficiarios.some(bene => bene.parentesco.codigo === 1 || bene.parentesco.codigo === 19 ||
        bene.parentesco.codigo === 30 || bene.parentesco.codigo === 31 || bene.parentesco.codigo === 40 ||
        bene.parentesco.codigo === 41)

    return tiene ? 'S' : 'N'
}

export const obtenerTipoCobranza = (producto, solicitudes, recurre) => {
    let idSol = obtenerIdSolicitud(producto, solicitudes)
    let tipo = recurre.find(sol => sol.idSolicitud === idSol).codigoTipoCobranza

    return tipo
}

export const obtenerIdSolicitud = (producto, solicitudes) => {
    let id = solicitudes.find(sol => sol.codigoProducto === producto.codigoProducto).idSolicitud

    return id
}

export const transformarStringFechaToFormato = (fechaString, formatoDestino) => {
    let dia, mes, anio, fecha, horas, minutos, segundos

    if (fechaString !== null && fechaString.constructor.name === 'Date') {
        fecha = fechaString
        dia = fecha.getDate()
        mes = fecha.getMonth() + 1
        anio = fecha.getFullYear()
        horas = fecha.getHours()
        minutos = fecha.getMinutes()
        segundos = fecha.getSeconds()
    } else if (fechaString !== null && fechaString.constructor.name === 'String') {
        if (fechaString.constructor.name !== 'Date' && fechaString.indexOf('/') > -1) {
            fecha = fechaString
            dia = fechaString.substring(0, 2)
            mes = fechaString.substring(3, 5)
            anio = fechaString.substring(6, 10)
        } else if (fechaString.constructor.name !== 'Date' && fechaString.indexOf('-') > -1) {
            fecha = fechaString
            anio = fechaString.substring(0, 4)
            mes = fechaString.substring(5, 7)
            dia = fechaString.substring(8, 10)
            horas = fechaString.substring(11, 13)
            minutos = fechaString.substring(14, 16)
        } else if (fechaString.constructor.name !== 'Date' && fechaString.indexOf('T') > -1) {
            fecha = new Date(fechaString)
            dia = fecha.getDate()
            mes = fecha.getMonth() + 1
            anio = fecha.getFullYear()
        }
    } else if (fechaString === null){
        return '-'
    }

    if (parseInt(dia) < 10) {
        dia = '0' + parseInt(dia)
    }
    if (parseInt(mes) < 10) {
        mes = '0' + parseInt(mes)
    }

    if (formatoDestino === Constantes.FORMATO_FECHA_1) {
        return dia + '/' + mes + '/' + anio
    } else if (formatoDestino === Constantes.FORMATO_FECHA_2) {
        return anio + '-' + mes + '-' + dia
    } else if (formatoDestino === Constantes.FORMATO_FECHA_3) {
        return dia + '/' + mes + '/' + anio + ' ' + horas + ':' + minutos
    } else if (formatoDestino === Constantes.FORMATO_FECHA_4) {
        return anio + '-' + mes + '-' + dia + ' ' + horas + ':' + minutos + ':' + segundos
    } else if(formatoDestino === Constantes.FORMATO_FECHA_5) {
        return anio + '.' + mes + '.' + dia + '.' + horas + '.' + minutos
    } else {
        return null
    }
}

export const limpiarTexto = (valor) => {
    let salida = ''
    if(valor !== undefined && valor !== null) {
        let texts = valor.split(' ')
        texts.map((text, index) => {
            if(text.trim() !== '') {
                salida = (index !== 0 ? (salida + ' ') : '') + text.trim()
            } else {
                salida = salida + (index === texts.length - 1 ? ' ' : '') + text.trim()
            }
            return text
        })
    } 
    return salida
}

export const obtenerParamQuery = (url, campo) => {
    if(url !== undefined && url !== null && url.trim() !== '') {
        let cadena = url.substr(url.indexOf('?') + 1, url.length)
        if(cadena.trim() !== '') {
            let arrayParams = []
            let valores = cadena.split('&')
            for(let valor of valores) {
                arrayParams.push({
                    campo: valor.substr(0, valor.indexOf('=')),
                    valor: valor.substr(valor.indexOf('=') + 1, valor.length)
                })
            }

            let paramSalida = arrayParams.filter(param => param.campo === campo)[0]
            if(paramSalida !== undefined && paramSalida !== null) {
                return paramSalida.valor
            }
        }
    }
    return null
}

export const base64ToJsonDecode = (base64) => {
    try {
        return JSON.parse(atob(base64))
    } catch (error) {
        console.error('Error Decode:', error)
        return null
    }
}

export const obtenerParametro = (parametros, idParametro, tipo) => {
    let salida = null
    let parametro = parametros.filter(parametro => parametro.idParametro === idParametro)[0]
    if(parametro !== undefined) {
        if(tipo === Constantes.TIPO_DATO_NUMERICO) {
            salida = parametro.valorNumerico
        } else {
            salida = parametro.valorCadena
        }
    }
    return salida
}

export function sentenceCase (input, lowercaseBefore) {
    input = ( input === undefined || input === null ) ? '' : input
    if (lowercaseBefore) { input = input.toLowerCase() }
    return input.toString().replace( /(^|\. *)([a-z])/g, function(match, separator, char) {
        return separator + char.toUpperCase()
    })
}

export const formatoMonedaEndoso = (monto) => {
    if (!monto) return '';
    const number = parseFloat(monto.toString().replace(/[^0-9.-]+/g, ''));
    if (isNaN(number)) return '';
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: 0 }).format(number);
}

export const getCurrentFormattedDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
};